export default __webpack_public_path__ + "static/media/img1.3230b41f.webp";